export default {"src":"/_next/static/media/skillz_light_theme_icon.79746e6c.svg","height":15,"width":71,"blurWidth":0,"blurHeight":0};